import React from 'react';

class Disclosure extends React.Component {

    render() {
        return (
            <div class="card">
                <h1 class="text-center m-3">COVID-R Disclosure</h1>
                <hr class="m-0"/>
                <p class= "m-lg-5 p-3">COVID-R is based on statistical models and provides a rough estimate of your risk for COVID-19. The information and content provided by this tool are not intended to replace advice from medical doctors or other health professionals, and shall not be used for the diagnosis or treatment of any medical condition, or for any medical or clinical decision-making. You shall not use the information to substitute for any activity, such as visit or consultation, with your healthcare provider. In no circumstance shall the authors and their affiliates be liable or responsible for any consequences involving the COVID-R app, including but not limited to, loss or injury of any kind. We do not save any information that you provide when using the tool, and information is disposed once you exit this app.</p>
                <button type="button" class="btn btn-primary m-3" onClick={this.props.onClick}>Accept &amp; Continue</button>
            </div>
        );
    }
}

export default Disclosure;
